import { Box } from '@chakra-ui/react';
import { PeOrderOperationType } from 'enums/modules/pe/peOperationType';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import PeCompanyRelatedOrderItem from './PeCompanyRelatedOrderItem';

interface Props {
  sharesproOrders: PeCompanyOrderListItem[];
}

const PeCompanyRelatedSharesproOrdersSection: FC<Props> = ({
  sharesproOrders,
}) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <>
      <GridHeading>{t('sharesproOffers')}</GridHeading>
      {sharesproOrders.map((order) => (
        <Box mb="20px" key={order.id}>
          <PeCompanyRelatedOrderItem
            sharePrice={order.price}
            volume={order.volume}
            quantity={order.quantity}
            lastRoundVolume={order.company.lastRoundVolume}
            currency={order.company.currency}
            onBuyClick={() =>
              navigate(
                AppRoute.createPeCompanyOrder(order.company.id, {
                  operation_type: PeOrderOperationType.Buy,
                  company_name: order.company.name,
                  quantity: order.quantity,
                  requested_price: order.company.price,
                  company_currency: order.company.currency.symbol,
                })
              )
            }
          />
        </Box>
      ))}
    </>
  );
};

export default PeCompanyRelatedSharesproOrdersSection;
